import React, { useCallback, FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Container from '@mui/material/Container'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'

import * as yup from 'yup'

import SectionHeader from '../components/widgets/SectionHeader'
import Link from '../components/widgets/Link'
import Form from '../components/form/Wrapper'

import useSnackbar from '../components/hooks/useSnackbar'
import authActions from '../store/modules/auth'
import authSelectors from '../store/selectors/auth'

import {
  FormSchema,
} from '../types/form'

interface FormType {
  name: string,
  email: string,
  password: string,
  confirm_password: string,
}

const formSchema: FormSchema = [{
  id: 'name',
  title: 'Franchise Name',
  helperText: 'Enter the name of your business',
}, {
  id: 'email',
  title: 'Email',
  helperText: 'Enter your email address',
}, {
  id: 'password',
  title: 'Password',
  helperText: 'Enter your password',
  inputProps: {
    type: 'password',
  },
}, {
  id: 'confirm_password',
  title: 'Confirm Password',
  helperText: 'Confirm your password',
  inputProps: {
    type: 'password',
  },
}]

const validationSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  password: yup.string().required(),
  confirm_password: yup.string().required(),
})

const Register: FC<React.PropsWithChildren<unknown>> = ({

}) => {
  const dispatch = useDispatch()
  const loading = useSelector(authSelectors.network.register.loading)
  const error = useSelector(authSelectors.network.register.error)
  const snackbar = useSnackbar()

  const onRegister = useCallback((payload: FormType) => {
    if(payload.password !== payload.confirm_password) {
      snackbar.error('Passwords do not match')
      return false
    }
    dispatch(authActions.register({
      name: payload.name,
      email: payload.email,
      password: payload.password,
    }))
  }, [])

  const initialValues: FormType = {
    name: '',
    email: '',
    password: '',
    confirm_password: '',
  }

  return (
    <Container
      maxWidth="sm"
    > 
      <SectionHeader
        title='Register'
        titleVariant='h2'
      />
      <Box
        sx={{
          p: 3,
        }}
      >
        <Form
          validationSchema={ validationSchema }         
          error={ error }
          initialValues={ initialValues }
          onSubmit={ onRegister }
        >
          {
            ({
              render,
              isValid,
              onSubmit,
            }) => {
              return (
                <Box>
                  { render(formSchema) }
                  <Box
                    mt={ 2 }
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      disabled={ loading || !isValid }
                      type="submit"
                      onClick={ onSubmit }
                      disableElevation
                    >
                      Register
                    </Button>
                  </Box>
                </Box>
                
              )
            }
          }
        </Form>
        <Box mt={4}>
          <Alert severity="info">
            If you already have an account, you can <Link name="login">login here</Link>.
          </Alert>
        </Box>
      </Box>
    </Container>
  )
}

export default Register